import { createAction } from 'redux-actions';

const setTimestamp: any = createAction('SET_TIMESTAMP', (value: string) => value);

export { setTimestamp };
